import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import Heading from '@/shared-components/text/components/Heading';

import AgreementContent from './AgreementContent';

import './index.css';

export default function ArtworkAgreement() {
  const goBackHandler = useGoBack("/");

  return (
    <>
      <div className="artwork-agreement__page">
        <div className="artwork-agreement__header">
          <BackArrowIcon className="artwork-agreement__back-button" onClick={goBackHandler}/>
          <SuarteName className="artwork-agreement__suartename"/>
        </div>

        <h1 className="artwork-agreement__heading">
          <Heading className="font-size-small">
                        Artwork Agreement
          </Heading>
        </h1>

        <AgreementContent />
      </div>
    </>
  );
}
